module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-LtIt.d7a3162.ttf";